import { darken } from "@mui/material/styles";

export const colors = {
  primary: {
    main: "#E01B3F",
    light: "#F46577",
    dark: darken("#E01B3F", 0.2),
    contrastText: "#FFFFFF",
    600: "#E01B3F",
    550: "#E7334A",
    500: "#EE374E",
    450: "#F1485E",
    400: "#F3596D",
    350: "#F46577",
    300: "#F97485",
    250: "#FA8090",
    200: "#FF94A1",
    150: "#FFAAB4",
    100: "#FFB8C1",
    50: "#FFDDE1",
  },
  greyGradient: {
    main: "#34303E",
    light: "#77757F",
    dark: "#0F0D15",
    contrastText: "#FFFFFF",
    600: "#0F0D15",
    550: "#1D1929",
    500: "#34303E",
    450: "#4A4754",
    400: "#615E69",
    350: "#77757F",
    300: "#8E8C94",
    250: "#A5A3A9",
    200: "#BBBABF",
    150: "#D2D1D4",
    100: "#E8E8EA",
    50: "#F9F9F9",
  },
  success: {
    main: "#1EE9B6",
    light: "#62F0CC",
    dark: darken("#1EE9B6", 0.2),
    contrastText: "#FFFFFF",
    600: "#18BA92",
    550: "#1BD2A4",
    500: "#1EE9B6",
    450: "#35EBBD",
    400: "#4BEDC5",
    350: "#62F0CC",
    300: "#78F2D3",
    250: "#8FF4DB",
    200: "#A5F6E2",
    150: "#BCF8E9",
    100: "#D2FBF0",
    50: "#E9FDF8",
  },
  info: {
    main: "#1A50FF",
    light: "#4D77FF",
    dark: darken("#1A50FF", 0.2),
    contrastText: "#FFFFFF",
    600: "#0030CC",
    550: "#0036E6",
    500: "#003CFF",
    450: "#1A50FF",
    400: "#3363FF",
    350: "#4D77FF",
    300: "#668AFF",
    250: "#809EFF",
    200: "#99B1FF",
    150: "#B3C5FF",
    100: "#CCD8FF",
    50: "#E6ECFF",
  },
  secondary: {
    main: "#FFC10A",
    light: "#FFE165",
    dark: "#B89606",
    contrastText: "#0F0D15",
    600: "#CCB243",
    550: "#E6C84C",
    500: "#FFDE54",
    450: "#FFE165",
    400: "#FFE576",
    350: "#FFE887",
    300: "#FFEB98",
    250: "#FFEFAA",
    200: "#FFF2BB",
    150: "#FFF5CC",
    100: "#FFF8DD",
    50: "#FFFCEE",
  },
  warning: {
    main: "#FF6E01",
    light: "#FF9A4D",
    dark: darken("#FF6E01", 0.2),
    contrastText: "#FFFFFF",
    600: "#CC5801",
    550: "#E66301",
    500: "#FF6E01",
    450: "#FF7D1A",
    400: "#FF8B34",
    350: "#FF9A4D",
    300: "#FFA867",
    250: "#FFB780",
    200: "#FFC599",
    150: "#FFD4B3",
    100: "#FFE2CC",
    50: "#FFF1E6",
  },
  error: {
    main: "#F42829",
    light: "#F76969",
    dark: darken("#F42829", 0.2),
    contrastText: "#FFFFFF",
    600: "#C32021",
    550: "#DC2425",
    500: "#F42829",
    450: "#F53E3E",
    400: "#F65354",
    350: "#F76969",
    300: "#F87E7F",
    250: "#F87E7F",
    200: "#FBA9A9",
    150: "#FCBFBF",
    100: "#FDD4D4",
    50: "#FEEAEA",
  },
  purple: {
    main: "#AE59C6",
    light: "#E49AFA",
    dark: "#8A35A2",
    contrastText: "#FFFFFF",
    600: "#AE59C6",
    550: "#C364DF",
    500: "#D96FF8",
    450: "#DD7DF9",
    400: "#E18CF9",
    350: "#E49AFA",
    300: "#E8A9FB",
    250: "#ECB7FC",
    200: "#F0C5FC",
    150: "#F4D4FD",
    100: "#F7E2FE",
    50: "#FBF1FE",
  },
  pink: {
    main: "#FA0082",
    light: "#FC4DA8",
    dark: darken("#FA0082", 0.2),
    contrastText: "#FFFFFF",
    600: "#C80068",
    550: "#E10075",
    500: "#FA0082",
    450: "#FB1A8F",
    400: "#FB339B",
    350: "#FC4DA8",
    300: "#FC66B4",
    250: "#FD80C1",
    200: "#FD99CD",
    150: "#FEB3DA",
    100: "#FECCE6",
    50: "#FFE6F3",
  },
};
